import { VerticalContainer } from '@american-autonomy/ag-ui';

import AdvancedSection from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/AdvancedSection';
import CoverageOptionsSection from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/CoverageOptionsSection';
import PrimaryParamsSection from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/PrimaryParamsSection';
import SpraySettingsSection from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/SpraySettingsSection';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FlightPlannerSections: FunctionComponent<Props> = ({
    className = '',
    config,
    isAdvancedOpen,
    isCoverageOpen,
    isHomePointPickDisabled,
    isPickingHomePoint,
    isSprayOpen,
    onAdvancedToggle,
    onConfigChange,
    onCoverageToggle,
    onPickHomePoint,
    onSpraySettingsChange,
    onSprayToggle,
    spraySettings,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${className} ${styles.flightPlannerSections}`} testId={testId}>
        {config && <PrimaryParamsSection config={config} onConfigChange={onConfigChange} />}

        {config && (
            <CoverageOptionsSection
                config={config}
                isHomePointPickDisabled={isHomePointPickDisabled}
                isOpen={isCoverageOpen}
                isPickingHomePoint={isPickingHomePoint}
                onConfigChange={onConfigChange}
                onPickHomePoint={onPickHomePoint}
                onToggle={onCoverageToggle}
            />
        )}

        {config && (
            <AdvancedSection
                config={config}
                isOpen={isAdvancedOpen}
                onConfigChange={onConfigChange}
                onToggle={onAdvancedToggle}>
                <SpraySettingsSection
                    isOpen={isSprayOpen}
                    onSpraySettingsChange={onSpraySettingsChange}
                    onToggle={onSprayToggle}
                    spraySettings={spraySettings}
                />
            </AdvancedSection>
        )}
    </VerticalContainer>
);

export default FlightPlannerSections;
